import React, { FunctionComponent, memo } from "react";
import { faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { Button } from "@edgetier/components";
import { IProps } from "./show-sidebar-button.types";
import SidebarContext from "~/sidebar-context";
import "./show-sidebar-button.scss";

/**
 * Button to open a sidebar.
 * @param props.label Button label.
 * @returns           Button.
 */
const ShowSidebarButton: FunctionComponent<IProps> = ({ label }) => {
    const { showSidebar } = React.useContext(SidebarContext);

    return (
        <Button onClick={() => showSidebar()} icon={faEllipsisH} styleName="neutral">
            {label}
        </Button>
    );
};

export default memo(ShowSidebarButton);
